import months from 'Shared/data/months';
import { colors } from 'Shared/util/theme';
import { getPieChartData } from 'Shared/util/translations';


const pieChartStatusInfo = [{
  status: 'notDue',
  sortOrder: 1,
  color: colors.chart.first,
}, {
  status: 'overdue',
  sortOrder: 2,
  color: colors.chart.second,
}, {
  status: 'reminder',
  sortOrder: 3,
  color: colors.chart.third,
}, {
  status: 'collection',
  sortOrder: 4,
  color: colors.chart.fourth,
}, {
  status: 'legalAction',
  sortOrder: 5,
  color: colors.chart.fifth,
}];

const getMonthText = (yearAndMonth) => {
  const month = parseInt(yearAndMonth.substring(5, 7), 10);
  return months[month - 1].label.toLowerCase();
};


export const getPieChartDataCount = (invoices, t) => {
  const data = getPieChartData(pieChartStatusInfo, invoices, 'status', t);
  const chartData = data.chartData.reduce((acc, obj) => {
    acc[obj.event] = obj.count;
    return acc;
  }, {});

  return {
    data: chartData,
    colors: data.chartColors,
  };
};

export const getPieChartDataAmount = (invoices, t) => {
  const data = getPieChartData(pieChartStatusInfo, invoices, 'status', t);
  const chartData = data.chartData.reduce((acc, obj) => {
    acc[obj.event] = obj.amount;
    return acc;
  }, {});
  return {
    data: chartData,
    colors: data.chartColors,
  };
};

export const getBarChartData = (averagePayments) => {
  if (!averagePayments) return {};

  return averagePayments.reduce((result, obj) => {
    const existingObject = result.find((o) => o.month === obj.month);
    if (!existingObject) {
      result.push({
        month: obj.month, // getMonthText(obj.month),
        sum: obj.averagePaymentDays,
        count: 1,
      });
      return result;
    }

    existingObject.sum += obj.averagePaymentDays;
    existingObject.count += 1;
    return result;
  }, [])
    .reduce((result, obj) => {
      result[obj.month] = (obj.sum / obj.count).toFixed(1);
      return result;
    }, {});
};
